import { Checkbox, Button } from "@mui/material";
import Styles from './Styles.module.css'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Actions } from '../../Action/index';
import { updateCurationStatus, getQuestionDraftData, fetchAttachmentURL, getTabSearchData, getTrendingData, deleteAnswerrecord } from '../../API/api';
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import styles from './Styles.module.css'
import { handleError } from '../../utils';
import { CURRENT_ROLE } from '../../API/url';
import { CloseOutlined } from "@mui/icons-material";
{/* <CloseOutlined /> */ }


const textStyles = {
  fontSize: "16px",
  color: "#ffff",
  lineHeight: "24px",
  fontWeight: "500",
  wordBreak: 'break-word',overflowWrap: 'break-word',
};

const actionBarStyles = {
  container: {
    position: "fixed",
    bottom: "20px",
    left: "5%",
    width: "100%",
    // padding: "0 15px",
    marginBottom: "35px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
    backgroundColor: "transparent",
  },
  container1: {
    width: "100%",
    maxWidth: "600px",
    background: "#5E6676",
    borderRadius: "36px",
    boxShadow: "0px 4px 16px 0px #1018280F",
    // padding: "12px 15px",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    gap: "12px",
    paddingTop:"10px",
    paddingBottom:"10px"
  },
  text: {
    fontSize: "16px",
    fontWeight: "500",
    color: "#fff",
  },
  closeIcon: {
    color: "#fff",
    cursor: "pointer",
    marginLeft: "auto", // Push to end
  },
};
const actionBarStyle = {
  container: {
    position: "fixed",
    bottom: "20px",
    width: "50%",
    backgroundColor: "transparent",

    padding: "0px 12px 0px 12px",
    // boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.1)",
    // borderTop: "1px solid #ddd",
    marginBottom: "35px",
    display: "flex",
    justifyContent: "center",


    // border:"none"
  },
  container1: {
    width: "auto",
    margin: "auto",
    // marginTop: "1%",
    marginBottom: "1%",
    border: "1px solidrgb(153, 156, 163)",
    background: "#5E6676",
    borderRadius: "36px",
    boxShadow: "0px 4px 16px 0px #1018280F",
    // padding: "18px",
    display: "flex",
    // justifyContent: "center",
    alignItems: "center",
    gap:"18px",
    paddingLeft:"18px",
    paddingRight:"18px",
    paddingTop:"10px",
    paddingBottom:"10px"
    

  },
  innerContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  text: {
    fontSize: "16px",
    fontWeight: "500",
    marginRight: "12px",
  },
  checkbox: {
    transform: "scale(1.5)",
    marginRight: "15px",
  },
  deleteButton: {
    backgroundColor: "#FF4C4C",
    color: "#fff",
    marginRight: "10px",
    textTransform: "none",
  },
  evergreenButton: {
    backgroundColor: "#28A745",
    color: "#fff",
    textTransform: "none",
  }
};

const ActionBar = ({ selectedCount, onSelectAll, onDelete, onMarkEvergreen, selectedAnswers, tabsearchQuery, setSelectedAnswers, curationFilter, fetchData, fetchDataCount }) => {
  const [disabled, setDisabled] = useState(false)

  const currentPath = useLocation();
  const submitSuccessToast = (message) => {
    return (
      <>
        <span style={{ fontSize: "12px" }}>
          {message}
        </span>
      </>
    );
  };
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const { markedAnsweredData, updatePageNoAnswered, IsLoadingAnsweredtab, updateAnsweredTabData, updateRatingBoolean, getScrollPositionInExpertOpen, AnsweredPageBool, updateAnswerTextForEditor } = bindActionCreators(Actions, dispatch)
  const [loader, setLoader] = useState(true)
  const dataname = "answeredQuestions"
  let pageState = useSelector((state) => state[dataname]);

  const buttonDarkStyle = {
    minWidh: '100px',
    border: '1px solid #E0E2E6',
    padding: '8px 24px 8px 24px',
    borderRadius: '8px',
    boxShadow: ' 0px 1px 2px 0px #1018280D',
    fontSize: '14px',
    color: '#2A364A',
    // marginRight:'8px',
    background: '#F6F7F8',
    fontWeight: '400',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    cursor: disabled ? "not-allowed" : "pointer"
    // minWidth:`${minWidth}`,
    // ...(minWidth !== undefined && { justifyContent:'center'})
  }
  const isCheckRelevance = (str) => {
    let isThere = false;
    for (let i = 0; i < str.length; ++i) {
      if (str[i].label === "Relevance") {
        isThere = true;
      }
    }
    return isThere;
  };
  const excludedValues = ['transferred', '1', '2', '3']; // Exclude these from filteredDomains
  const curationValues = ['1', '2', '3']; // Values for curationCategory
  // const prevDeps = useRef({});
  const isTransferred = pageState.domains.some(domain => domain.value === 'transferred'); // Check if 'transferred' exists

  const filteredDomains = pageState.domains.filter(domain => !excludedValues.includes(domain.value)); // Remove 'transferred', '1', '2', '3'
  const curationCategory = pageState.domains
    .filter(domain => curationValues.includes(domain.value)) // Get only '1', '2', '3'
    .map(domain => domain.value); // Extract values
  const searchCuration = curationCategory.length > 0 ? curationCategory.map(Number).join(",") : "";

  const searchDomain = filteredDomains.length > 0 ? curationCategory : "";

  const successfulDeleteQuestion = (message) => {
    return (
      <span style={{ fontSize: '12px' }}>{message}</span>
    )
  }
  const onClickButton = (answer, key) => {
    setDisabled(true)
    getScrollPositionInExpertOpen(null)
    IsLoadingAnsweredtab(true)
    setLoader(false)


    const data = answer?.map((uuid) => ({
      answerUuidStr: uuid, // Each item in answerArray is already a UUID
      curationStatus: 'curated',
      evergreen: key === "evergreen" ? true : false
    }));



    updateCurationStatus(data).then(res => {
      if (res === undefined) return;
      if (res.data.success) {
        fetchData()

        toast.success(submitSuccessToast(res.data.message), {
          position: toast.POSITION.TOP_RIGHT,
        });
        setSelectedAnswers([])
        setDisabled(false)
        fetchDataCount()
        // markedAnsweredData(filteredData);

      }
    })
  }
  let id = (arr) => {
    let data = []
    let uuid = "";
    arr.filter(ids => {
      if (ids !== undefined) {
        uuid = ids;
      }
    })

    let val = { answerUuidStr: uuid };
    data.push(val)
    return data
  }
  const Delete = (answer) => {
    setDisabled(true)
    // console.log("selected", answer)
    const data = answer?.map((uuid) => ({
      answerUuidStr: uuid,
    }));


    deleteAnswerrecord(data).then(res => {
     
      if (res === undefined) return;
    
      updateRatingBoolean(true)
      IsLoadingAnsweredtab(true)
      if (res.data.success) {
        updateAnsweredTabData({
          data: [],
          count:0,
      });
        toast.success(successfulDeleteQuestion(res.data.message), {
          position: toast.POSITION.TOP_RIGHT
        });
        setSelectedAnswers([])
        setDisabled(false)
        //   markedAnsweredData(updatedData);
      
      }
      fetchData()
      fetchDataCount()
    
    })
  }


  return (
    <>
      {
        curationFilter === "pending" ? <>
          <div style={actionBarStyles.container}>
            <div style={actionBarStyles.container1}>
              <span style={textStyles}>{selectedCount} Selected</span>


              <button
                // variant="contained"
                disabled={disabled}
                onClick={() => Delete(selectedAnswers)}
                style={buttonDarkStyle}

              >
                Delete
              </button>
              {
                curationFilter === "pending" &&

                <>
                  <button
                    disabled={disabled}
                    // variant="contained"
                    onClick={() => onClickButton(selectedAnswers, "evergreen")}
                    style={buttonDarkStyle}

                  >
                    Mark Evergreen
                  </button>
                  <button
                    // variant="contained"
                    disabled={disabled}
                    onClick={() => onClickButton(selectedAnswers, "curated")}
                    className={Styles.buttonPrimary}
                    style={{ pointerEvents: disabled ? "none" : "" }}
                  >
                    Mark Curated
                  </button>

                </>

              }
              <CloseOutlined style={{ color: "#ffff", cursor: "pointer" }} onClick={() => setSelectedAnswers([])} />

            </div>



          </div>

        </> : <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
          <div style={actionBarStyle.container}>
            <div style={actionBarStyle.container1}>
              <span style={textStyles}>{selectedCount} Selected</span>


              <button
                // variant="contained"
                disabled={disabled}
                onClick={() => Delete(selectedAnswers)}
                style={buttonDarkStyle}

              >
                Delete
              </button>
              <CloseOutlined style={{ color: "#ffff", cursor: "pointer" }} onClick={() => setSelectedAnswers([])} />

            </div>

          </div>

        </div>


      }
      { }

    </>

  );
};

// 🔹 CSS Styles


export default ActionBar;
